import React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok";
import * as styles from "./richtext.module.css"

const Paragraph = ({ blok }) => {
  // console.log(blok)
  return (
    <div className="container max-w-[750px] mx-auto px-5 py-10" {...storyblokEditable(blok)}>
      <h2 className="text-3xl font-bold font-serif text-center">{blok.title}</h2>
      <div className={`${styles.richText}`} dangerouslySetInnerHTML={{ __html: renderRichText(blok.text) }}></div>
    </div>
  )
};

export default Paragraph;
